import queryString from "query-string";
import {
    GET_COMPARE
} from "../../api/history_budget";

const state = {
    historyData: []
    // mode: "",
};

const mutations = {
    SET_HISTORY: (states, payload) => {
        states.historyData = payload;
    },
};

const actions = {
    GET_HISTORY: async ({
        commit
    }, query) => {
        query = queryString.stringify(query);
        const resp = await GET_COMPARE(query);
        const data = resp.data.data;
        commit("SET_HISTORY", data);
    },
};

const getters = {
    dataHistory: (states) => states.historyData,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};